import clsx from 'clsx';

import Logo, { TLogo } from '@@/common/components/Logo';

import classes from './LogoWrapper.module.css';

export type TLogoWrapper = {
  overrideClasses?: {
    root?: string;
    logo?: string;
    img_wrapper?: string;
  };
} & Omit<
  TLogo,
  'overrideClasses' | 'logos' | 'redirectUrls' | 'tenantDisplayName'
>;

function LogoWrapper({ overrideClasses, ...props }: TLogoWrapper) {
  return (
    <div className={clsx(classes.root, overrideClasses?.root)}>
      <Logo
        {...props}
        overrideClasses={{
          root: overrideClasses?.logo,
          img_wrapper: clsx(classes.img_wrapper, overrideClasses?.img_wrapper),
        }}
      />
    </div>
  );
}

export default LogoWrapper;
